import React from "react";
import styled, { css } from "styled-components";
import { lastStateChangeF } from "../../lib/trays/TrayUtils";
import classNames from "classnames";

const Container = styled.div`
  border: 1px solid #ccc;
  border-radius: 0px;
  margin-right: 10px;
  margin-bottom: 10px;
  opacity: 0.5;
  font-size: 11pt;
  display: flex;

  ${(props) =>
    props &&
    props.item_count > 0 &&
    css`
      opacity: 1;
    `};

  > .heading {
    cursor: pointer;
    display: flex;
    justify-content: flex-start;
    background-color: #eee;

    .count {
      background-color: white;
      // padding: 3px;
      padding-left: 7px;
      padding-right: 7px;
      // margin-right: 15px;
      ${(props) =>
        (props && props.item_count) || props.active > 0
          ? css`
              font-weight: bold;
              color: black;
            `
          : css`
              font-weight: normal;
              color: #888;
            `};
    }
    .text {
      // padding: 3px;
      color: black;
      // font-weight: bold;
      padding-left: 10px;
      padding-right: 10px;
      text-align: center;
      font-size: 11pt;
    }
    .complete_count {
      // padding: 3px;
      padding-left: 8px;
      padding-right: 8px;
      background-color: #8f8fff;
      color: white;
      text-align: center;
      // width: 55px;
      font-weight: bold;
    }
    .reviewed_count {
      // padding: 3px;
      padding-left: 8px;
      padding-right: 8px;
      background-color: #55bb55;
      color: white;
      text-align: center;
      // width: 55px;
      font-weight: bold;
    }
  }

  &.active {
    opacity: 1;
    border: 2px solid #555;
    > .heading {
      background-color: #ff7777 !important;
      .text {
        color: white;
      }
    }
  }

  &.medium {
    margin-right: 20px;
    > .heading {
      .count {
        font-size: 14pt;
        // padding: 5px;
        padding-left: 20px;
        padding-right: 20px;
      }
      .text {
        // padding: 5px;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 13pt;
      }
      .complete_count {
        font-size: 13pt;
      }
      .reviewed_count {
        font-size: 13pt;
      }
    }
  }

  &.fully_reported {
    border: 2px solid #8f8fff;

    > .heading {
      background-color: #8f8fff !important;
      .text {
        color: white;
      }
    }
  }
  &.selected {
    border: 3px dashed black;
  }
  > .select-tray {
    // padding: 5px;
    padding-left: 6px;
    padding-right: 6px;
    margin: 0px;
  }
  > .priority-techniques {
    padding-left: 8px;
    padding-right: 8px;
    margin: 0px;
    background-color: red;
    color: white;
  }
  > .priority-matrices {
    padding-left: 8px;
    padding-right: 8px;
    margin: 0px;
    background-color: red;
    color: white;
  }
`;

export default function Tray({
  tray,
  active,
  style,
  handleActivateTray,
  medium,
  showTechniques,
  handleSelectTray,
  selected,
  displayOptions: { showStateChangeDate } = { showStateChangeDate: true },
  displayOptions = {},
  showCheckbox = true,
}) {
  var reportedCount = null;
  var reviewedCount = null;
  if (tray.item_count > 0 && typeof tray.reported_count !== "undefined") {
    reportedCount = Math.round((tray.reported_count / tray.item_count) * 100.0);
  }
  if (tray.item_count > 0 && typeof tray.reviewed_count !== "undefined") {
    reviewedCount = Math.round((tray.reviewed_count / tray.item_count) * 100.0);
  }

  const hasPriorityTechniques =
    tray.technique_ids &&
    displayOptions.priorityTechniqueIds &&
    displayOptions.priorityTechniqueIds.length > 0 &&
    tray.technique_ids.filter((id) => displayOptions.priorityTechniqueIds.includes(id))
      .length > 0;
  const hasPriorityMatrices =
    tray.matrix_ids &&
    displayOptions.priorityMatrixIds &&
    displayOptions.priorityMatrixIds.length > 0 &&
    tray.matrix_ids.filter((id) => displayOptions.priorityMatrixIds.includes(id)).length > 0;

  return (
    <Container
      active={active}
      medium={medium}
      style={style}
      item_count={tray.item_count || 0}
      fullyReported={tray.fully_reported}
      className={classNames({
        active,
        medium,
        selected,
        fully_reported: tray.fully_reported,
      })}
    >
      <div className="heading" onClick={handleActivateTray}>
        <div className="count">{tray.state === "discarded" ? " " : tray.item_count}</div>
        {showStateChangeDate && (
          <div className="text">
            {tray.technique_list &&
              tray.technique_list.length > 0 &&
              tray.technique_list.map((technique) => (
                <span>
                  {technique} {technique !== tray.technique_list.last && <br />}
                  <hr />
                </span>
              ))}
            {/* {!tray.technique_list && (lastStateChangeF(tray) || tray.item.name)} */}
            {!tray.technique_list && tray.item.name}
          </div>
        )}
        {reportedCount != null &&
          reportedCount > 0 && (
            <div className="complete_count">
              {reportedCount == 100 ? <i className="fa fa-check" /> : reportedCount + "%"}
            </div>
          )}
        {reviewedCount != null &&
          reviewedCount > 0 && (
            <div className="reviewed_count">
              {reviewedCount == 100 ? <i className="fa fa-check" /> : reviewedCount + "%"}
            </div>
          )}
      </div>
      {hasPriorityTechniques && (
        <label className="priority-techniques">
          <i className="fa fa-exclamation" />
          &nbsp; T
        </label>
      )}
      {hasPriorityMatrices && (
        <label className="priority-matrices">
          <i className="fa fa-exclamation" />
          &nbsp; M
        </label>
      )}
      {showCheckbox && (
        <label className="select-tray">
          <input type="checkbox" checked={selected} onClick={handleSelectTray} />
        </label>
      )}
    </Container>
  );
}
